import script from "./HistoricoAcessos_71.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoricoAcessos_71.vue?vue&type=script&setup=true&lang=js"

import "./HistoricoAcessos_71.vue?vue&type=style&index=0&id=23497f86&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23497f86"]])

export default __exports__